import * as React from 'react';
import Link from '../../Link';
import icon from '../../../assets/images/icon-my-energy-alt.svg';
import { Container } from 'semantic-ui-react';
import InlineSvg from '../../InlineSvg';

export default function Portal() {
  return (
    <div className="mobile-menu__portal">
      <Container className="mobile-menu__portal-container">
        <Link
          to="https://customermeterdata.portal.powercor.com.au/customermeterdata/"
          target="_blank"
          className="mobile-menu__portal-link"
        >
          <img src={icon} alt="myEnergy" className="mobile-menu__portal-icon" />
          <div className="mobile-menu__portal-content">
            <h4>myEnergy</h4>
            <p>Track how your home or business uses electricity over time.</p>
          </div>
          <InlineSvg
            name="arrow"
            className="mobile-menu__portal-arrow"
            color="brand-secondary"
          />
        </Link>
      </Container>
    </div>
  );
}
